<template>
  <div class="space-bottom">
    <b-row class="align-items-center">
      <b-col md="4" cols="12">
        <div class="d-flex mt-2">
          <p class="mt-2 mr-3 f-18px">เลขที่เอกสาร</p>
          <InputText
            type="text"
            className=" bg-second flex-grow-1"
            placeholder="เลขที่"
            textField=""
            :value="form.document_no"
            disabled
          />
          <b-button class="ml-2" @click="printDoc(1)" v-if="id > 0">
            <font-awesome-icon icon="print" class="pointer text-white" />
          </b-button>
        </div>
      </b-col>
      <b-col md="4" cols="12">
        <div class="mt-2"></div>
      </b-col>
      <!-- <b-col md="4" cols="12">
        <div class="mt-2">
          <p class="mt-2 mr-2 title text-right">
            ผู้สร้าง : {{ form.created_user_guid }} (
            {{ form.created_user_name }}
            {{
              $moment(form.created_date).add(543, "years").format("DD/MM/YYYY")
            }}
            ) สถานะ : {{ form.repairStatusName || "รับเข้าสาขา" }}
            <span
              :class="{
                'text-success':
                  form.repair_user_transaction_id ||
                  (form.delivery_date && totalPrice == 0),
                'text-error':
                  !form.repair_user_transaction_id ||
                  (!form.delivery_date && totalPrice == 0),
              }"
              v-if="form.repair_status_id == 2"
            >
              {{
                form.repair_user_transaction_id
                  ? "(ชำระเงินแล้ว) "
                  : form.delivery_date && !totalPrice
                  ? "(ส่งมอบแล้ว)"
                  : totalPrice > 0 && !form.repair_user_transaction_id
                  ? "(ยังไม่ชำระเงิน)"
                  : "(ยังไม่ส่งมอบ)"
              }}
            </span>
          </p>
          <p class="mt-2 mr-2 title text-right" v-if="form.billNo">
            หมายเลขใบเสร็จ :
            <span
              class="text-link"
              @click="
                $router.push(
                  `/transaction/detail/${form.repair_user_transaction_id}/${form.customer_user_guid}/0`
                )
              "
              >{{ form.billNo }}</span
            >
          </p>
        </div>
      </b-col> -->
    </b-row>
    <b-tabs class="mt-3">
      <b-tab title="Detail">
        <b-row class="mt-3">
          <b-col md="4" cols="12">
            <!-- <div class="d-flex align-items-center f-14">
              <p class="text-gray title-w">ชื่อลูกค้า</p>
              <p class="text-gray">:</p>
              <div class="display-user-value ml-2">
                {{ form.customer_user_name }}
              </div>
              <font-awesome-icon
                v-if="id == 0"
                @click="handleSearch(1)"
                :icon="['fas', 'search']"
                class="pointer fa-search text-white"
                id="search-icon"
              />
            </div> -->
            <div class="d-flex align-items-center mt-1 f-14">
              <p class="text-gray title-w">ชื่อผู้ขายคืน</p>
              <p class="text-gray">:</p>
              <div class="display-user-value ml-2">
                {{ form.buy_back_user_name }}
              </div>
              <font-awesome-icon
                v-if="id == 0"
                @click="handleSearch(2)"
                :icon="['fas', 'search']"
                class="pointer fa-search text-white"
                id="search-icon"
              />
            </div>

            <div class="d-flex align-items-center mt-2 f-14">
              <p class="text-gray title-w">วิธีการรับเงิน</p>
              <p class="text-gray">:</p>
              <b-button
                v-if="id == 0"
                class="ml-2 custom-btn"
                @click="selectRefundType()"
              >
                วิธีการรับเงิน
              </b-button>

              <p class="ml-2 text-wrap" v-if="form.user_return_payment_id">
                {{ form.user_return_payment.return_payment_name }} |
                {{ form.user_return_payment.return_bank_name }} เลขบัญชี
                {{ form.user_return_payment.bank_account_number }}
              </p>
            </div>
            <div class="d-flex align-items-start mt-2 f-14">
              <p class="text-gray title-w">หมายเลขเอกสารการจ่ายเงิน</p>
              <p class="text-gray">:</p>
              <div class="ml-2">
                <div
                  v-for="(no, index) in form.payment_document_no_list"
                  :key="'key' + index"
                  class="d-flex align-items-center"
                >
                  {{ no }}
                </div>
              </div>
            </div>
          </b-col>

          <b-col md="3" cols="12">
            <div class="d-flex align-items-center mt-1 f-14">
              <p class="text-gray title-w f-14">ประเภทขายคืน</p>
              <p class="text-gray">:</p>

              <InputSelect
                class="ml-2 w-50"
                :options="buyBackTypeList"
                v-model="form.return_payment_id"
                :disabled="form.status_id > 0"
                @onDataChange="(val) => (form.return_payment_id = val)"
                textField="text"
                valueField="id"
              ></InputSelect>
            </div>
          </b-col>

          <b-col md="2" cols="12">
            <div class="d-flex align-items-center mt-2 f-14">
              <p class="text-gray title-w">ตรวจสภาพโดย (คลัง)</p>
              <p class="text-gray">:</p>
              <div class="ml-2">{{ form.payment_staff_no }}</div>
            </div>

            <div class="d-flex align-items-center mt-2 f-14">
              <p class="text-gray title-w">ผู้ทำบัญชี</p>
              <p class="text-gray">:</p>
              <div class="ml-2">{{ form.accountant_staff_no }}</div>
            </div>
          </b-col>
          <b-col md="3" cols="12">
            <div class="d-flex align-items-center mt-2 f-14">
              <p class="text-gray title-w">หมายเลขใบส่งคืนคลัง</p>
              <p class="text-gray">:</p>
              <div
                class="ml-2 text-link"
                @click="
                  $router.push(
                    `/inventory-transfer/0/detail/${form.inventory_transfer_send_id}`
                  )
                "
              >
                {{ form.inventory_transfer_document_no_send }}
              </div>
              <b-button class="ml-2" @click="printDoc(2)" v-if="id > 0">
                <font-awesome-icon icon="print" class="pointer text-white" />
              </b-button>
            </div>

            <div class="d-flex align-items-center f-14">
              <p class="text-gray title-w">หมายเลขอ้างชำระ</p>
              <p class="text-gray mr-2">:</p>
              {{ form.payment_reference_no }}
            </div>
          </b-col>
          <b-col cols="12">
            <div class="d-flex align-items-center mt-5">
              <p class="title">สินค้า</p>
              <b-button
                class="btn-width mb-2"
                :disabled="id > 0"
                @click="addItems()"
                >เพิ่มสินค้า</b-button
              >
            </div>
            <div v-for="(item, index) in form.items" :key="'item-' + index">
              <div
                class="bg-tabs-custom px-2 py-3"
                :class="{ 'mb-3': !item.visible }"
              >
                <div>
                  <font-awesome-icon
                    :icon="
                      !item.visible
                        ? ['fas', 'chevron-circle-down']
                        : ['fas', 'chevron-circle-up']
                    "
                    class="pointer text-main"
                    :aria-expanded="item.visible ? 'true' : 'false'"
                    :aria-controls="'collapse' + index"
                    @click="item.visible = !item.visible"
                  ></font-awesome-icon>

                  Product Name : {{ item.product_name || item.name }}
                </div>
                <div>
                  Price: {{ item.total | numeral("0,0.00") }}
                  <font-awesome-icon
                    v-if="id == 0"
                    icon="trash-alt"
                    title="delete-btn"
                    size="lg"
                    class="text-danger icon-delete icon-size"
                    :class="{ pointer: item.productId }"
                    @click="deleteItem(index)"
                  />
                </div>
              </div>
              <b-collapse
                class="p-3 crad-custom mb-3"
                :id="'collapse' + index"
                v-model="item.visible"
              >
                <div class="card p-3 mb-0">
                  <b-row>
                    <b-col md="6" cols="12">
                      <div class="d-flex align-items-center f-14">
                        <p class="text-gray title-w">ชื่อลูกค้า</p>
                        <p class="text-gray">:</p>
                        <div class="display-user-value ml-2">
                          {{ item.user_name }}
                        </div>
                        <font-awesome-icon
                          v-if="id == 0"
                          @click="handleSearch(1, index)"
                          :icon="['fas', 'search']"
                          class="pointer fa-search text-white"
                          id="search-icon"
                        />
                      </div>
                      <div class="d-flex align-items-center mt-2 f-14">
                        <p class="text-gray title-w">เลขที่ใบเสร็จ</p>
                        <p class="text-gray">:</p>
                        <a
                          class="ml-2 text-link"
                          :href="`/transaction/detail/${
                            item.userTransactionId ||
                            item.target_user_transaction_product_id
                          }/${item.user_guid}/0`"
                          >{{ item.invoiceNo || item.invoice_no }}</a
                        >
                      </div>
                      <div class="d-flex align-items-center mt-2 f-14">
                        <p class="text-gray title-w">วันที่ซื้อ</p>
                        <p class="text-gray">:</p>
                        <p class="ml-2">
                          {{
                            item.created_time
                              ? $moment(item.created_time).format("DD/MM/yyyy")
                              : ""
                          }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center mt-2 f-14">
                        <p class="text-gray title-w">ชื่อสินค้า</p>
                        <p class="text-gray">:</p>
                        <a
                          class="ml-2 text-link"
                          :href="`/product/detail/${
                            item.productId || item.product_id
                          }`"
                          target="_blank"
                        >
                          {{ item.name }}
                          {{ item.product_name || item.name }}
                          {{ item.serial ? `(Serial: ${item.serial})` : "" }}
                        </a>
                      </div>
                    </b-col>
                    <b-col md="5" cols="12" align-self="stretch">
                      <div class="d-flex align-items-start mt-2 f-14">
                        <p class="text-gray title-w">รูปสินค้า</p>
                        <p class="text-gray mr-2">:</p>

                        <div v-if="item.product_name || item.name">
                          <img
                            :src="item.image_url || item.imageUrl"
                            class="img-size"
                            v-if="item.image_url || item.imageUrl"
                          />
                          <img
                            v-else
                            src="@/assets/images/noimg.png"
                            alt="no-image-product"
                            class="img-size"
                          />
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-2 f-14">
                        <p class="text-gray title-w">Gold Type</p>
                        <p class="text-gray">:</p>
                        <div class="ml-2">
                          {{ item.gold_type_name || "-" }}
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-2 f-14">
                        <p class="text-gray title-w">ราคาทองรับซื้อ</p>
                        <p class="text-gray">:</p>
                        <div class="ml-2">
                          {{ item.priceBaht | numeral("0,0.00") }} บาท/บาท
                        </div>
                      </div>
                      <div class="d-flex align-items-center mt-2 f-14">
                        <p class="text-gray title-w">ราคาทองรับซื้อ</p>
                        <p class="text-gray">:</p>
                        <div class="ml-2">
                          {{ item.priceGram | numeral("0,0.00") }} บาท/กรัม
                        </div>
                      </div>
                    </b-col>
                    <b-col md="1" cols="12">
                      <b-button
                        class="mb-2"
                        :disabled="id > 0"
                        @click="openSelectBuybackProduct(index)"
                        >เลือกสินค้า</b-button
                      >
                    </b-col>
                  </b-row>

                  <p class="title mt-3">ประวัติการซ่อม</p>
                  <RepairLog
                    :fields="fieldLog"
                    :items="item.history"
                    class="mt-2"
                  />
                  <InputTextArea
                    :disabled="form.status_id > 0 || !item.productId"
                    v-model="item.remark"
                    textFloat="หมายเหตุ"
                    placeholder="หมายเหตุ"
                    rows="3"
                  >
                  </InputTextArea>
                  <div class="d-flex w-100">
                    <b-row>
                      <template>
                        <b-col
                          :key="'repair' + n"
                          md="4"
                          cols="12"
                          v-for="(field, n) of item.custom_field.answers"
                        >
                          <RepairCustomFields
                            :isDisabled="form.status_id > 0 || !item.productId"
                            :form="item.custom_field.answers"
                            :key="field.name"
                            :field="field"
                            :n="n"
                            @onAddImage="(images) => (field.value = images)"
                            :index="n"
                          />
                        </b-col>
                      </template>
                    </b-row>
                  </div>
                  <div class="text-right">
                    <b-button
                      v-if="id == 0"
                      :disabled="form.status_id > 0 || !item.productId"
                      class="ml-2 custom-btn"
                      @click="calPrice(item, index)"
                    >
                      คำนวณราคา
                    </b-button>
                  </div>
                </div>
              </b-collapse>
              <hr v-if="index == form.items.length - 1" />
            </div>
            <h2 class="text-right">
              Total : {{ totalPrice | numeral("0,0.00") }}
            </h2>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <FooterAction
      :routePath="'/buy-back'"
      @submit="confirmAlertModal()"
      :hideSubmit="id > 0"
    ></FooterAction>
    <ModalAlertConfirm
      ref="modalAlertConfirm"
      :msg="confirmMessage.msg"
      :text="confirmMessage.text"
      @confirm="(val, test) => saveForm(val)"
    />
    <ModalRefundType
      ref="modalRefundtype"
      :userGuid="form.buy_back_user_guid"
      @selectPayment="selectPayment"
    ></ModalRefundType>
    <ModalCustomerList
      ref="modalCustomerList"
      @setUserSelect="setUserSelect"
      :isRepair="true"
    />

    <ModalSearchRepairProduct
      :isRepair="true"
      :isMobile="isMobile"
      ref="modalSearchRepairProduct"
      :productList="form.items"
      @setSelectProduct="addBuybackProduct"
    >
    </ModalSearchRepairProduct>
    <ModalRepairPayment
      ref="modalPayment"
      :paymentChannelList="paymentChannelList"
      @confirm="confirmPayment"
    ></ModalRepairPayment>
    <ModalBillDetails
      ref="modalBillDetails"
      :paymentChannelList="paymentChannelList"
      :isFullPos="isFullPos"
    />
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "../../../components/inputs/InputTextArea.vue";
import FooterAction from "@/components/FooterAction";
import InputSelect from "@/components/inputs/InputSelect";
import { mapGetters } from "vuex";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCustomerList from "../home/components/ModalCustomerList.vue";
import ModalRefundType from "./components/ModalRefundType.vue";
import ModalSearchRepairProduct from "./components/ModalSearchRepairProduct.vue";
import TextEditorsTiny from "@/components/inputs/TextEditorsTiny.vue";
import ModalRepairPayment from "./components/ModalRepairPayment.vue";
import ModalBillDetails from "../home/components/ModalBillDetails.vue";
import { required } from "vuelidate/lib/validators";
import RepairCustomFields from "../repairProduct/components/RepairCustomFields.vue";
import RepairLog from "../repairProduct/components/RepairLog.vue";
export default {
  components: {
    InputText,
    InputTextArea,
    FooterAction,
    ModalAlertConfirm,
    ModalCustomerList,
    ModalRefundType,
    RepairLog,
    InputSelect,
    RepairCustomFields,
    ModalSearchRepairProduct,
    TextEditorsTiny,
    ModalRepairPayment,
    ModalBillDetails,
  },
  validations() {
    return {
      note: {
        text: {
          required,
        },
      },
    };
  },

  data() {
    return {
      tabIndex: 0,
      isBusy: false,

      filter: {
        search: "",
        page: 1,
        take: 10,
        member: {
          search: "",
          searchType: 0,
        },
      },

      productList: [],

      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      rows: 0,
      id: this.$route.params.id,
      form: {
        user_return_payment_id: 0,
        return_payment_id: 1,
        check_condition_user_name: "",
        check_condition_user_guid: "",
        buy_back_user_guid: "",
        buy_back_user_name: "",
        accountant_user_guid: "",
        accountant_user_name: "",

        payee_user_name: "",
        payee_user_guid: "",
        remark: "",
        items: [
          {
            visible: true,
            remark: "",
            total: 0,
            history: [],
            custom_field: {
              answers: [],
            },
            user_guid: "",
            user_name: "",
          },
        ],
      },
      customerList: [],
      modalMessage: "",
      isSaved: false,
      confirmMessage: {
        text: "",
        msg: "",
      },
      now: null,
      fieldLog: [
        {
          label: "เลขเอกสาร",
          key: "document_no",
          thStyle: { "min-width": "120px" },
        },
        {
          label: "วันที่รับเข้าซ่อม",
          key: "created_time",
          thStyle: { "min-width": "120px" },
        },
        {
          label: "หัวข้อการซ่อม",
          key: "name",
          thStyle: { "min-width": "120px" },
        },
        {
          label: "บันทึกการซ่อม",
          key: "remark",
          thStyle: { "min-width": "120px" },
        },
      ],
      itemsLog: [],
      buyBackTypeList: [
        { id: 1, text: "รับเงิน" },
        { id: 2, text: "Store Credit" },
      ],
      fieldsSerial: [
        { key: "name", label: "รายการ" },
        { key: "value", label: "น้ำหนักก่อนซ่อม" },
      ],
      isMobile: false,
      returnPayment: {},
      id: this.$route.params.id,
      fieldSetting: [],
      noteList: [],
      note: {
        repair_transaction_id: this.$route.params.id,
        text: "",
        items: [],
      },
      fileAttach: [],
      isAddNote: false,
      paymentChannelList: [],
      transaction: {},
      itemsSerialCustomField: [],
      searchArticle: "",
      warranty: "",
      productDetail: [],
      sendId: 0,
      payments: null,
      setIndex: null,
    };
  },
  async created() {
    this.now = this.$moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    if (this.id > 0) {
      await this.getDetail();
    }
    if (this.id == 0) {
      this.form.created_user_guid = this.$cookies.get("saleId");
    }
    await this.getFieldSetting();
  },

  computed: {
    totalPrice() {
      return this.form.items.reduce((sum, item) => sum + (item.total || 0), 0);
    },
    ...mapGetters({
      mainLoading: "getMainLoading",
      userGuid: "getUserGuid",
      isFullPos: "getIsFullPos",
      branchId: "getBranchId",
      plantId: "getPlantId",
      salesNo: "getSalesNo",
      branchName: "getBranchName",
      branchType: "getBranchType",
    }),
  },

  methods: {
    async getDetail() {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.$axios(
        `${this.$baseUrl}/buyback/Detail/${this.id}`
      );
      this.form = res.detail;
      // await this.getHistory();
      let log = res.detail.items.map((x) => ({
        history: x.history,
        fields: x.fields,
      }));

      const addedFieldIds = new Set();

      log.forEach((item) => {
        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((field) => {
            const key = field.id.toString();

            if (!addedFieldIds.has(field.id)) {
              this.fieldLog.push({
                key: key,
                label: field.name,
                thStyle: { width: "200px" },
              });
              addedFieldIds.add(field.id);
            }
          });
        }
      });

      this.form.items.forEach((item) => {
        item.history = item.history.map((item) => {
          const customFieldMap = {};

          if (item.fields && Array.isArray(item.fields)) {
            item.fields.forEach((answer, index) => {
              customFieldMap[answer.id] = {
                value: item.answers[index].item2 || "-",
                type: answer.field_type_id || "-",
              };
            });
          }
          const name = {
            name: {
              value: item.items ? item.items[0].name || "-" : "-",
            },
          };

          return {
            ...item,
            ...customFieldMap,
            ...name,
          };
        });
      });

      if (this.form.repair_status_id == 2) {
        await this.getPaymentChannel();
      }

      await this.$store.dispatch("setMainLoading", false);
    },
    async getPaymentChannel() {
      await this.axios
        .get(`${this.$baseUrl}/Transaction/GetPaymentChannel`)
        .then(async (data) => {
          if (data.result == 1) {
            this.paymentChannelList = data.detail;
          }
        });
    },
    async getHistory(userTransactionProductId) {
      const res = await this.$axios(
        `${this.$baseUrl}/repair/History/${
          this.form.items[this.setIndex].user_guid
        }/${userTransactionProductId}`
      );
      let log = res.detail;

      const addedFieldIds = new Set();
      log.history.forEach((item) => {
        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((field) => {
            const key = field.id.toString();

            if (!addedFieldIds.has(field.id)) {
              this.fieldLog.push({
                key: key,
                label: field.name,
                thStyle: { width: "200px" },
              });
              addedFieldIds.add(field.id);
            }
          });
        }
      });
      const lastIndex = this.form.items.length - 1;
      const lastItem = this.form.items[lastIndex];
      if (lastItem) {
        lastItem.history = log.history.map((item) => {
          const customFieldMap = {};

          if (item.fields && Array.isArray(item.fields)) {
            item.fields.forEach((answer, index) => {
              customFieldMap[answer.id] = {
                value: item.answers[index].item2 || "-",
                type: answer.field_type_id || "-",
              };
            });
          }

          const name = {
            name: {
              value: item.items[0].name || "-",
            },
          };

          return {
            ...item,
            ...customFieldMap,
            ...name,
          };
        });
      }
    },

    async getFieldSetting() {
      const res = await this.$axios(`${this.$baseUrl}/buyback/FieldSetting`);
      this.fieldSetting = res.detail;
      this.form.items.forEach((item, index) => {
        item.visible = index == 0 ? true : false;
        item.custom_field = {
          ...item.custom_field,
          answers: this.buildCustomAnswers(),
        };
      });
    },

    async handleSearch(type, index) {
      this.customerList = [];
      if (this.id > 0) {
        return;
      }
      this.filter.member.searchType = type;
      this.setIndex = index;
      this.$refs.modalCustomerList.show(this.filter.member.search);
    },
    async setUserSelect(user) {
      if (this.filter.member.searchType == 1) {
        this.form.items[this.setIndex] = {
          visible: true,
          remark: "",
          user_guid: "",
          user_name: "",
          history: [],
          custom_field: {
            answers: this.buildCustomAnswers(),
          },
        };

        this.form.items[this.setIndex].user_name =
          user.first_name_th +
          " " +
          (user.last_name_th ? user.last_name_th : "");
        this.form.items[this.setIndex].user_guid = user.user_guid;

        this.$forceUpdate();
      } else if (this.filter.member.searchType == 2) {
        this.form.user_return_payment = {};
        this.form.user_return_payment_id = 0;
        this.form.buy_back_user_name =
          user.first_name_th + " " + user.last_name_th;
        this.form.buy_back_user_guid = user.user_guid;
        await this.getUserReturnList();
        let payment = this.payments.find((x) => x.is_default);
        if (payment) {
          this.returnPayment = payment;
          this.form.user_return_payment = payment;
          this.form.user_return_payment_id = payment.id;
        }
      } else if (this.filter.member.searchType == 3) {
        this.form.payee_user_name =
          user.first_name_th + " " + user.last_name_th;
        this.form.payee_user_guid = user.user_guid;
      }
    },
    selectRefundType() {
      if (!this.form.buy_back_user_guid) {
        return this.errorAlert("กรุณาเลือกชื่อผู้ขายคืน");
      }
      this.$refs.modalRefundtype.show();
    },
    async confirmAlertModal() {
      // if (this.form.repair_status_id == 2) {
      //   if (this.totalPrice > 0) return this.openModalPayment();
      //   else {
      //     this.confirmMessage = {
      //       msg: "ยืนยันการทำรายการ",
      //     };
      //     this.sendId = this.id;
      //     this.$refs.modalAlertConfirm.show(true);
      //   }
      // }
      this.form.items.forEach((item) => {
        if (
          item &&
          item.custom_field &&
          Array.isArray(item.custom_field.answers)
        ) {
          item.custom_field.answers.forEach((answer) => {
            if (Array.isArray(answer.value)) {
              this.$set(answer, "value", answer.value.join(",").toSผูtring());
            } else {
              answer.value = answer.value.toString();
            }
          });
        }
      });

      this.$nextTick();

      if (!this.form.items[0].productId) {
        return this.errorAlert("กรุณาเลือกสินค้า");
      } else if (!this.form.buy_back_user_guid) {
        return this.errorAlert("กรุณาเลือกชื่อผู้ขายคืน");
      } else if (!this.form.user_return_payment_id) {
        return this.errorAlert("กรุณาเลือกวิธีการรับเงิน");
      } else {
        this.confirmMessage = {
          msg: "ยืนยันการทำรายการ",
        };
        this.$refs.modalAlertConfirm.show();
      }
    },
    async addBuybackProduct(product) {
      await this.$store.dispatch("setMainLoading", true);
      const newItem = {
        visible: true,
        ...product,
        product_name: product.name,
        image_url: product.imageUrl,
        total: 0,
        inventory_product_serial_id: product.inventoryProductSerialId,
        target_user_transaction_product_id: product.userTransactionProductId,
        history: [],
        user_guid:
          this.form.items[this.setIndex].user_guid || product.user_guid,
        user_name:
          this.form.items[this.setIndex].user_name || product.user_name,
        custom_field: {
          answers: this.buildCustomAnswers(),
        },
      };
      this.$set(this.form.items, this.setIndex, newItem);
      await this.getHistory(product.userTransactionProductId);
      await this.$store.dispatch("setMainLoading", false);
    },
    buildCustomAnswers() {
      return this.fieldSetting.map((x, index) => {
        const answer = this.form.items
          .flatMap((item) => item.custom_field.answers || [])
          .find((a) => a.product_custom_field_id === x.id && a.id !== 0);
        let value = "";

        if (answer) {
          value = answer.value || "";

          if (x.field_type_id == 2) {
            const splitArray = value.split(",");
            value = [...new Set(splitArray.map(Number))];
          }
        } else if (x.field_choices && this.id == 0) {
          const defaultChoices = x.field_choices.filter(
            (f) => f.isDefault == 1
          );

          if (
            x.field_type_id == 2 &&
            x.field_choices.length > 0 &&
            this.id == 0
          ) {
            const defaultIds = defaultChoices.map((f) => f.id);
            value = [...new Set(defaultIds)];
          } else if (
            x.field_type_id == 3 ||
            (x.field_type_id == 4 && this.id == 0)
          ) {
            const firstDefault = defaultChoices[0];
            if (firstDefault) {
              value = firstDefault.id;
            }
          }
        }

        return {
          ...x,
          value: value.toString(),
          product_custom_field_id: x.id,
          id: 0,
        };
      });
    },
    openSelectBuybackProduct(index) {
      this.setIndex = index;
      this.$refs.modalSearchRepairProduct.show(this.form.items[index]);
    },
    selectPayment(payment) {
      this.returnPayment = payment;
      this.form.user_return_payment = payment;
      this.form.user_return_payment_id = payment.id;
    },
    async saveForm() {
      if (this.id > 0) {
        await this.$store.dispatch("setMainLoading", true);
        const res = await this.$axios.put(`${this.$baseUrl}/repair/Update`, {
          ...this.form,
          inventory_product_serial_id:
            this.form.product.inventoryProductSerialId,
        });
        if (res.result == 1) {
          this.successAlert(res.detail.message),
            this.$router.push(`/buy-back/detail/${this.id}`);
        } else this.errorAlert(res.message);

        await this.$store.dispatch("setMainLoading", false);
        return;
      }
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.$axios.post(`${this.$baseUrl}/buyback/Save`, {
        ...this.form,
      });
      if (res.result == 1) {
        this.successAlert(res.detail.message),
          // this.exportTransaction(res.detail);
          this.$router.push(`/buy-back/detail/${res.detail}`);
      } else this.errorAlert(res.message);

      await this.$store.dispatch("setMainLoading", false);
    },

    replaceCharacter(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    cancelAddnote() {
      this.$v.note.$reset();
      this.note.text = "";
      this.note.items = [];
      this.isAddNote = false;
    },
    async openModalPayment() {
      await this.calculateTransaction();
      this.$refs.modalPayment.show(
        this.form,
        this.transaction,
        this.productDetail
      );
    },

    async calculateTransaction() {
      const res = await this.$axios(
        `${this.$baseUrl}/repair/calculate_transaction_data/${this.id}`
      );
      this.transaction = res.price;
      this.productDetail = res.detail;
    },
    async confirmPayment(payment = null) {
      let product = this.form.items.map((prod, index) => {
        return {
          id: prod.product_id,
          q: 1,
          group_barcode: "",
          sap_discount: prod.sap_discount || [],
          item_discount: prod.item_discount || [],
          product_group_barcode: prod.product_group_barcode || 0,
          gp_product_barcode: prod.gp_product_barcode || 0,
          product_group_barcode_id: prod.barcode_group_id || 0,
          serial: prod.serial || "",
          custom_price: prod.price || 0,
        };
      });

      let credit = 0;
      // if (this.form.credit) {
      //   credit = { ...this.form.credit };
      //   credit.expired_date = this.$moment(credit.expired_date)
      //     .add(543, "years")
      //     .format("DD/MM/YYYY");
      // }
      let body = {
        price: [],
        promotion: [],
        product: product,
        // credit: credit,
        user_guid: this.form.customer_user_guid,

        branch_id: this.branchId,
        t_datetime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        sales_id: this.form.created_user_guid,
        invoice_no: this.form.invoiceNo,
        is_fullpos: this.isFullPos,
        user_get_point: 1,
        new_customer: "0",
        tourist: "0",
        partner: "0",
        partner_detail: "",
        zero_point: "0",
        payment_channel_id: payment ? payment.id : 1,
        payment_amount: payment ? payment.amount : 0,
        payments: payment ? payment.payments : [],
      };

      await this.$store.dispatch("setMainLoading", true);
      await this.axios
        .post(
          `${this.$baseUrl}/repair/submit_transaction_data/${this.id}`,
          body
        )
        .then(async (data) => {
          await this.$store.dispatch("setMainLoading", false);
          if (data.result == 1) {
            console.log(data.result == 1);

            if (this.isFullPos == 1) {
              this.axios.post("http://localhost:30033/api/PrintReceipt", {
                Base64String: data.print_file,
              });

              this.axios.get("http://localhost:30033/api/cashdrawer");
            }
            this.$refs.modalBillDetails.show(
              data,
              this.form.customer_user_guid
            );
            await this.getDetail();
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    async exportTransaction(transaction) {
      try {
        const response = await this.axios.get(
          `${this.$baseUrl}/repair/report/${transaction}`,
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `repair-transaction-${transaction}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading PDF:", error);
      }
    },
    async getUserReturnList() {
      console.log(this.form.buy_back_user_guid);
      await this.axios(
        `${this.$baseUrl}/UserReturnPayment/list/${this.form.buy_back_user_guid}`
      ).then(async (data) => {
        if (data.result == 1) {
          this.payments = data.detail.datas;
        }
      });
    },
    deleteItem(index) {
      if (this.form.items.length == 1) {
        this.form.items[0] = {
          visible: true,
          remark: "",
          user_guid: "",
          user_name: "",
          history: [],
          custom_field: {
            answers: this.buildCustomAnswers(),
          },
        };

        this.$forceUpdate();
      } else {
        this.form.items.splice(index, 1);
      }
    },
    async calPrice(item, index) {
      await this.$store.dispatch("setMainLoading", true);

      let body = {
        answers: item.custom_field.answers.map((answer) => {
          return {
            product_custom_field_id: answer.product_custom_field_id,
            value:
              answer.value.type === "array"
                ? answer.value.join(",")
                : answer.value,
          };
        }),
      };
      const res = await this.axios.post(
        `${this.$baseUrl}/buyback/CalculatePrice/${item.target_user_transaction_product_id}`,
        {
          body,
        }
      );
      if (res.result == 1) {
        this.form.items[index].total = res.detail;
        this.$forceUpdate();
        await this.$store.dispatch("setMainLoading", false);
      } else {
        this.errorAlert(res.message);
        await this.$store.dispatch("setMainLoading", false);
      }
    },
    addItems() {
      let newBlankItem = {
        visible: true,
        remark: "",
        total: 0,
        history: [],
        custom_field: {
          answers: this.buildCustomAnswers() || [],
        },
        user_guid: "",
        user_name: "",
      };

      this.form.items.push({ ...newBlankItem });
    },
    async printDoc(type) {
      let filePath;
      let fileName;
      if (type == 1) {
        filePath = this.form.document_file_path;
        fileName = this.form.document_no || "document";
        try {
          const response = await fetch(filePath);
          const blob = await response.blob();

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${fileName}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Download failed:", error);
        }
      } else if (type === 2) {
        filePath = this.form.inventory_transfer_send_id;
        fileName = this.form.inventory_transfer_document_no_send;

        const res = await this.axios.get(
          `${this.$baseUrl}/InvoiceConsignment/transfer/Report/${filePath}/1`,
          { responseType: "blob" }
        );

        const blob = new Blob([res], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #333 !important;
  font-size: 16x !important;
  font-weight: bold !important;
}

.title-w {
  width: 200px;
}

.display-user-value {
  border: #c9c8c8 1px solid;
  width: 230px;
  min-height: 30px;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  padding: 2px 10px;
  font-size: 14px;
  color: #404040;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    color: #404040;
    font-size: 10px;
  }
}

.fa-search {
  width: 32px;
  height: 32px;
  margin-left: 10px;
  border-radius: 50%;
  border: 1px none #fff;
  background-color: var(--primary-color) !important;
  padding: 5px 7px;
}
.custom-btn {
  height: 32px;
  width: 120px;
}

.calendar-icon {
  position: absolute;
  top: 20%;
  right: 3%;
}
.calendar-icon-top {
  top: 35% !important;
}
.datetime-container {
  position: relative;
  width: 230px;
}

.custom-date-picker ::v-deep input {
  height: 35px !important;
}

.space-bottom {
  padding-bottom: 80px;
}

.img-size {
  width: 200px;
  height: 200px;
}

.title-detail {
  color: #333 !important;
  font-size: 16x !important;
  font-weight: bold !important;
}

.input-w {
  width: 300px !important;
}

.activity-footer {
  display: flex;
  justify-content: flex-end;
  margin: 24px 0;
  gap: 8px;
}

.action-button {
  color: black;
  background-color: rgb(225 225 225);

  padding: 0.5rem;
  display: inline-flex;
  font-size: 16px;
  cursor: pointer;
}

.f-18px {
  font-size: 18px;
  font-weight: bold;
}

.bg-tabs-custom {
  display: flex;
  justify-content: space-between;
  border: none;
  background: var(--secondary-color);
  border-radius: 0px;
  color: var(--font-color);
  font-size: 14px;
  font-weight: bold;
}

.crad-custom {
  border-right: 1px solid;
  border-left: 1px solid;
  border-bottom: 1px solid;
  border-color: #d8dbe0;
  border-radius: 0.25rem;
}

.text-main {
  color: var(--font-color);
}
</style>
